import tw, { styled } from 'twin.macro';

const Label = styled.label(({ variant }) => [
  tw`text-sm font-bold leading-7 text-gray-400`,
  variant === 'default' && tw`mb-4`,
]);

export default Label;
